import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import organisationReducer from '../organisationSlice';
import userReducer from '../userSlice';
import { rekisterointiApi } from '../rekisterointiApi';
const store = configureStore({
    reducer: {
        [rekisterointiApi.reducerPath]: rekisterointiApi.reducer,
        organisation: organisationReducer,
        user: userReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(rekisterointiApi.middleware),
});
export default store;
export const useJotpaRekisterointiDispatch = useDispatch;
export const useJotpaRekisterointiSelector = useSelector;
